import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Grid, Header, Icon, Button } from "semantic-ui-react";
import { getExternalServicesStatus } from "services/externalServices";
import moment from "moment";

const styles = {
	blocWhite: {
		boxShadow: "0px 9px 35px -23px rgba(148,148,148,1)",
		backgroundColor: "#fff",
		padding: 20,
		borderRadius: "0 0 4px 4px",
		overflowY: "auto",
	},
	blocHeader: {
		backgroundColor: "rgb(0, 147, 128)",
		padding: 10,
		width: "100%",
		borderRadius: "4px 4px 0 0",
		color: "white",
	},
};

const ExternalServices = () => {
	const [status, setStatus] = useState([]);
	const dispatch = useDispatch();
	useEffect(() => {
		dispatch(getExternalServicesStatus()).then((res) => {
			if (res && res.payload && res.payload.data && res.payload.data) setStatus(res.payload.data);
		});
	}, []);
	return (
		<Grid textAlign="left" style={{ height: "100vh" }} verticalAlign="top">
			<Grid.Column style={{ maxWidth: 950, padding: "50px 20px", margin: "auto", height: "93vh" }}>
				<Header as="h2" color="teal" textAlign="center" style={{ backgroundColor: "rgb(0, 147, 128)", borderRadius: "4px" }}>
					<div
						style={{
							display: "flex",
							justifyContent: "space-between",
							alignItems: "baseline",
							color: "white",
							backgroundColor: "rgb(67, 179, 158)",
							padding: "10px",
							borderRadius: "4px",
						}}
					>
						<div>Statut des services externes</div>

						<Button
							icon
							color="teal"
							size="tiny"
							onClick={() =>
								dispatch(getExternalServicesStatus()).then((res) => {
									if (res && res.payload && res.payload.data && res.payload.data) setStatus(res.payload.data);
								})
							}
						>
							<Icon name="refresh" />
						</Button>
					</div>
				</Header>

				<div style={styles.blocWhite}>
					{status.length > 0 && (
						<Grid style={{ margin: 0 }}>
							{status.length > 0 && (
								<Grid.Row style={{ display: "flex", fontSize: "large", color: "teal" }}>
									<Grid.Column
										mobile={4}
										tablet={4}
										computer={4}
										style={{
											justifyContent: "space-between",
											width: "100%",
										}}
									>
										Nom du service
									</Grid.Column>
									<Grid.Column
										mobile={4}
										tablet={4}
										computer={4}
										style={{
											justifyContent: "space-between",
											width: "100%",
										}}
									>
										Nombre d'erreurs rencontrées
									</Grid.Column>
									<Grid.Column
										mobile={4}
										tablet={4}
										computer={4}
										style={{
											justifyContent: "space-between",
											width: "100%",
										}}
									>
										Nombre d'erreurs maximum
									</Grid.Column>
									<Grid.Column
										mobile={4}
										tablet={4}
										computer={4}
										style={{
											justifyContent: "space-between",
											width: "100%",
										}}
									>
										Email interruption de service envoyé
									</Grid.Column>
								</Grid.Row>
							)}
							{status.map((statusApp) => (
								<Grid.Row key={statusApp.serviceName}>
									<Grid.Column
										mobile={4}
										tablet={4}
										computer={4}
										style={{
											justifyContent: "space-between",
											width: "100%",
										}}
									>
										{statusApp.serviceName}
									</Grid.Column>
									<Grid.Column
										mobile={4}
										tablet={4}
										computer={4}
										style={{
											justifyContent: "space-between",
											width: "100%",
										}}
									>
										{statusApp.currentFailure}
									</Grid.Column>
									<Grid.Column
										mobile={4}
										tablet={4}
										computer={4}
										style={{
											justifyContent: "space-between",
											width: "100%",
										}}
									>
										{" "}
										{statusApp.maxAcceptedFailure}
									</Grid.Column>
									<Grid.Column
										mobile={4}
										tablet={4}
										computer={4}
										style={{
											justifyContent: "space-between",
											width: "100%",
										}}
									>
										{statusApp.sendEmailAt ? moment(statusApp.sendEmailAt).format("DD/MM/YYYY HH:mm") : "non envoyé"}
									</Grid.Column>
								</Grid.Row>
							))}
						</Grid>
					)}
				</div>
			</Grid.Column>
		</Grid>
	);
};

export default ExternalServices;
